const punjabi = {
  name: "Punjabi",
  native_name: "ਪੰਜਾਬੀ",
  code: "pa",
};

const pa = {
  translation: {
    report_bug: "ਬੱਗ ਰਿਪੋਰਟ ਕਰੋ",
    import: "ਇੰਪੋਰਟ ਕਰੋ",
    file: "ਫਾਈਲ",
    new: "ਨਵਾਂ",
    new_window: "ਨਵੀਂ ਵਿੰਡੋ",
    open: "ਖੋਲ੍ਹੋ",
    save: "ਸੇਵ ਕਰੋ",
    save_as: "ਇਸ ਤਰ੍ਹਾਂ ਸੇਵ ਕਰੋ",
    save_as_template: "ਟੈਂਪਲੇਟ ਵਜੋਂ ਸੇਵ ਕਰੋ",
    template_saved: "ਟੈਂਪਲੇਟ ਸੇਵ ਹੋਇਆ!",
    rename: "ਨਾਮ ਬਦਲੋ",
    delete_diagram: "ਡਾਯਾਗ੍ਰਾਮ ਮਿਟਾਓ",
    are_you_sure_delete_diagram:
      "ਕੀ ਤੁਸੀਂ ਸੱਚਮੁੱਚ ਇਸ ਡਾਯਾਗ੍ਰਾਮ ਨੂੰ ਮਿਟਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ? ਇਹ ਕਾਰਵਾਈ ਅਟੱਲ ਹੈ।",
    oops_smth_went_wrong: "ਓਹੋ! ਕੁਝ ਗਲਤ ਹੋ ਗਿਆ।",
    import_diagram: "ਡਾਯਾਗ੍ਰਾਮ ਇੰਪੋਰਟ ਕਰੋ",
    import_from_source: "SQL ਤੋਂ ਇੰਪੋਰਟ ਕਰੋ",
    export_as: "ਇਸ ਤਰ੍ਹਾਂ ਐਕਸਪੋਰਟ ਕਰੋ",
    export_source: "SQL ਐਕਸਪੋਰਟ ਕਰੋ",
    models: "ਮਾਡਲ",
    exit: "ਬਾਹਰ ਜਾਓ",
    edit: "ਸੋਧੋ",
    undo: "ਅਣਡੂੰਹ ਕਰੋ",
    redo: "ਫਿਰ ਕਰੋ",
    clear: "ਸਾਫ਼ ਕਰੋ",
    are_you_sure_clear:
      "ਕੀ ਤੁਸੀਂ ਸੱਚਮੁੱਚ ਇਸ ਡਾਯਾਗ੍ਰਾਮ ਨੂੰ ਸਾਫ਼ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ? ਇਹ ਕਾਰਵਾਈ ਅਟੱਲ ਹੈ।",
    cut: "ਕਾਟੋ",
    copy: "ਕਾਪੀ ਕਰੋ",
    paste: "ਚਿਪਕਾਓ",
    duplicate: "ਨਕਲ ਕਰੋ",
    delete: "ਮਿਟਾਓ",
    copy_as_image: "ਤਸਵੀਰ ਵਜੋਂ ਕਾਪੀ ਕਰੋ",
    view: "ਵੇਖੋ",
    header: "ਮੇਨੂਬਾਰ",
    sidebar: "ਸਾਈਡਬਾਰ",
    issues: "ਮੁੱਦੇ",
    presentation_mode: "ਪੇਸ਼ਕਾਰੀ ਮੋਡ",
    strict_mode: "ਸਖ਼ਤ ਮੋਡ",
    field_details: "ਖੇਤਰ ਵੇਰਵਾ",
    reset_view: "ਵੇਖਣ ਨੂੰ ਰੀਸੈਟ ਕਰੋ",
    show_grid: "ਗਰਿੱਡ ਦਿਖਾਓ",
    show_cardinality: "ਕਾਰਡਿਨੈਲਿਟੀ ਦਿਖਾਓ",
    theme: "ਥੀਮ",
    light: "ਹਲਕਾ",
    dark: "ਹਨੇਰਾ",
    zoom_in: "ਜ਼ੂਮ ਇਨ",
    zoom_out: "ਜ਼ੂਮ ਆਊਟ",
    fullscreen: "ਪੂਰੀ ਸਕਰੀਨ",
    settings: "ਸੈਟਿੰਗ",
    show_timeline: "ਟਾਈਮਲਾਈਨ ਦਿਖਾਓ",
    autosave: "ਆਟੋ ਸੇਵ",
    panning: "ਪੈਨਿੰਗ",
    table_width: "ਟੇਬਲ ਦੀ ਚੌੜਾਈ",
    language: "ਭਾਸ਼ਾ",
    flush_storage: "ਸਟੋਰੇਜ ਸਾਫ਼ ਕਰੋ",
    are_you_sure_flush_storage:
      "ਕੀ ਤੁਸੀਂ ਸੱਚਮੁੱਚ ਸਟੋਰੇਜ ਨੂੰ ਸਾਫ਼ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ? ਇਹ ਤੁਹਾਡੇ ਸਾਰੇ ਡਾਯਾਗ੍ਰਾਮ ਅਤੇ ਕਸਟਮ ਟੈਂਪਲੇਟਾਂ ਨੂੰ ਅਟੱਲ ਤੌਰ 'ਤੇ ਹਟਾ ਦੇਵੇਗਾ।",
    storage_flushed: "ਸਟੋਰੇਜ ਸਾਫ਼ ਕੀਤਾ ਗਿਆ",
    help: "ਮਦਦ",
    shortcuts: "ਸ਼ਾਰਟਕਟ",
    ask_on_discord: "ਸਾਡੇ ਤੋਂ Discord 'ਤੇ ਪੁੱਛੋ",
    feedback: "ਫੀਡਬੈਕ",
    no_changes: "ਕੋਈ ਬਦਲਾਅ ਨਹੀਂ",
    loading: "ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...",
    last_saved: "ਆਖਰੀ ਵਾਰ ਸੇਵ ਕੀਤਾ",
    saving: "ਸੇਵ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
    failed_to_save: "ਸੇਵ ਕਰਨ ਵਿੱਚ ਅਸਫਲ",
    fit_window_reset: "ਵਿੰਡੋ ਫਿਟ / ਰੀਸੈਟ ਕਰੋ",
    zoom: "ਜ਼ੂਮ",
    add_table: "ਟੇਬਲ ਸ਼ਾਮਲ ਕਰੋ",
    add_area: "ਖੇਤਰ ਸ਼ਾਮਲ ਕਰੋ",
    add_note: "ਨੋਟ ਸ਼ਾਮਲ ਕਰੋ",
    add_type: "ਕਿਸਮ ਸ਼ਾਮਲ ਕਰੋ",
    to_do: "ਕਰਨ ਲਈ",
    tables: "ਟੇਬਲ",
    relationships: "ਸਬੰਧ",
    subject_areas: "ਵਿਸ਼ਾ ਖੇਤਰ",
    notes: "ਨੋਟ",
    types: "ਕਿਸਮਾਂ",
    search: "ਖੋਜੋ...",
    no_tables: "ਕੋਈ ਟੇਬਲ ਨਹੀਂ",
    no_tables_text: "ਆਪਣਾ ਡਾਯਾਗ੍ਰਾਮ ਬਣਾਉਣ ਦੀ ਸ਼ੁਰੂਆਤ ਕਰੋ!",
    no_relationships: "ਕੋਈ ਸਬੰਧ ਨਹੀਂ",
    no_relationships_text: "ਫੀਲਡਾਂ ਨੂੰ ਜੋੜਨ ਲਈ ਖਿੱਚੋ ਅਤੇ ਸਬੰਧ ਬਣਾਓ!",
    no_subject_areas: "ਕੋਈ ਵਿਸ਼ਾ ਖੇਤਰ ਨਹੀਂ",
    no_subject_areas_text: "ਟੇਬਲਾਂ ਨੂੰ ਸਮੂਹਬੱਧ ਕਰਨ ਲਈ ਵਿਸ਼ਾ ਖੇਤਰ ਸ਼ਾਮਲ ਕਰੋ!",
    no_notes: "ਕੋਈ ਨੋਟ ਨਹੀਂ",
    no_notes_text: "ਵਾਧੂ ਜਾਣਕਾਰੀ ਰਿਕਾਰਡ ਕਰਨ ਲਈ ਨੋਟਾਂ ਦੀ ਵਰਤੋਂ ਕਰੋ",
    no_types: "ਕੋਈ ਕਿਸਮਾਂ ਨਹੀਂ",
    no_types_text: "ਆਪਣੇ ਆਪ ਦੇ ਕਸਟਮ ਡਾਟਾ ਕਿਸਮਾਂ ਬਣਾਓ",
    no_issues: "ਕੋਈ ਸਮੱਸਿਆ ਨਹੀਂ ਮਿਲੀ।",
    strict_mode_is_on_no_issues:
      "ਸਖ਼ਤ ਮੋਡ ਬੰਦ ਹੈ ਇਸ ਲਈ ਕੋਈ ਸਮੱਸਿਆ ਨਹੀਂ ਦਿਖਾਈ ਜਾਵੇਗੀ।",
    name: "ਨਾਮ",
    type: "ਕਿਸਮ",
    null: "ਨੱਲ",
    not_null: "ਨੱਟ ਨੱਲ",
    primary: "ਪ੍ਰਾਈਮਰੀ",
    unique: "ਅਨੋਖਾ",
    autoincrement: "ਆਟੋ ਇੰਕਰੀਮੈਂਟ",
    default_value: "ਡਿਫਾਲਟ ਮੁੱਲ",
    check: "ਚੈਕ ਐਕਸਪਰੈਸ਼ਨ",
    this_will_appear_as_is:
      "*ਇਹ ਜਨਰੇਟ ਕੀਤੇ ਸਕ੍ਰਿਪਟ ਵਿੱਚ ਜਿਵੇਂ ਦਾ ਤਿਵੇਂ ਹੀ ਦਿਖੇਗਾ।",
    comment: "ਟਿੱਪਣੀ",
    add_field: "ਖੇਤਰ ਸ਼ਾਮਲ ਕਰੋ",
    values: "ਮੁੱਲ",
    size: "ਆਕਾਰ",
    precision: "ਸਟੀਕਤਾ",
    set_precision: "ਸਟੀਕਤਾ ਸੈਟ ਕਰੋ: (ਆਕਾਰ, ਅੰਕ)",
    use_for_batch_input: "ਬੈਚ ਇਨਪੁੱਟ ਲਈ ਵਰਤੋਂ ਕਰੋ",
    indices: "ਇੰਡਾਈਸ",
    add_index: "ਇੰਡੈਕਸ ਸ਼ਾਮਲ ਕਰੋ",
    select_fields: "ਖੇਤਰ ਚੁਣੋ",
    title: "ਸਿਰਲੇਖ",
    not_set: "ਸੈਟ ਨਹੀਂ ਕੀਤਾ ਗਿਆ",
    foreign: "ਵਿਦੇਸ਼ੀ",
    cardinality: "ਕਾਰਡਿਨੈਲਿਟੀ",
    on_update: "ਅੱਪਡੇਟ 'ਤੇ",
    on_delete: "ਹਟਾਓ 'ਤੇ",
    swap: "ਸਵੈਪ ਕਰੋ",
    one_to_one: "ਇੱਕ ਤੋਂ ਇੱਕ",
    one_to_many: "ਇੱਕ ਤੋਂ ਬਹੁਤ",
    many_to_one: "ਬਹੁਤ ਤੋਂ ਇੱਕ",
    content: "ਸਮੱਗਰੀ",
    types_info:
      "ਇਹ ਫੀਚਰ object-relational DBMS ਜਿਵੇਂ ਕਿ PostgreSQL ਲਈ ਹੈ।\nਜੇ MySQL ਜਾਂ MariaDB ਲਈ ਵਰਤੋਂ ਕੀਤੀ ਜਾਂਦੀ ਹੈ, ਤਾਂ ਇੱਕ JSON ਕਿਸਮ ਜਨਰੇਟ ਕੀਤੀ ਜਾਵੇਗੀ ਜਿਸ ਵਿੱਚ ਸੰਬੰਧਿਤ json ਵੈਧਤਾ ਚੈੱਕ ਹੋਵੇਗੀ।\nਜੇ SQLite ਲਈ ਵਰਤੋਂ ਕੀਤੀ ਜਾਵੇ ਤਾਂ ਇਸਨੂੰ BLOB ਵਿੱਚ ਬਦਲਿਆ ਜਾਵੇਗਾ।\nਜੇ MSSQL ਲਈ ਵਰਤੋਂ ਕੀਤੀ ਜਾਵੇ ਤਾਂ ਪਹਿਲੇ ਖੇਤਰ ਲਈ ਇੱਕ ਕਿਸਮ ਉਪਨਾਮ ਜਨਰੇਟ ਕੀਤਾ ਜਾਵੇਗਾ।",
    table_deleted: "ਟੇਬਲ ਮਿਟਾਈ ਗਈ",
    area_deleted: "ਖੇਤਰ ਮਿਟਾਇਆ ਗਿਆ",
    note_deleted: "ਨੋਟ ਮਿਟਾਇਆ ਗਿਆ",
    relationship_deleted: "ਸਬੰਧ ਮਿਟਾਇਆ ਗਿਆ",
    type_deleted: "ਕਿਸਮ ਮਿਟਾਈ ਗਈ",
    cannot_connect: "ਕਨੈਕਟ ਨਹੀਂ ਕਰ ਸਕਦੇ, ਕਾਲਮ ਦੀਆਂ ਕਿਸਮਾਂ ਵੱਖ-ਵੱਖ ਹਨ",
    copied_to_clipboard: "ਕਲਿੱਪਬੋਰਡ 'ਤੇ ਕਾਪੀ ਕੀਤਾ ਗਿਆ",
    create_new_diagram: "ਨਵਾਂ ਡਾਯਾਗ੍ਰਾਮ ਬਣਾਓ",
    cancel: "ਰੱਦ ਕਰੋ",
    open_diagram: "ਡਾਯਾਗ੍ਰਾਮ ਖੋਲ੍ਹੋ",
    rename_diagram: "ਡਾਯਾਗ੍ਰਾਮ ਦਾ ਨਾਮ ਬਦਲੋ",
    export: "ਐਕਸਪੋਰਟ ਕਰੋ",
    export_image: "ਤਸਵੀਰ ਐਕਸਪੋਰਟ ਕਰੋ",
    create: "ਬਣਾਓ",
    confirm: "ਪੁਸ਼ਟੀ ਕਰੋ",
    last_modified: "ਆਖਰੀ ਵਾਰ ਬਦਲਿਆ ਗਿਆ",
    drag_and_drop_files:
      "ਫਾਈਲ ਨੂੰ ਇੱਥੇ ਖਿੱਚੋ ਅਤੇ ਛੱਡੋ ਜਾਂ ਅੱਪਲੋਡ ਕਰਨ ਲਈ ਕਲਿੱਕ ਕਰੋ।",
    support_json_and_ddb: "JSON ਅਤੇ DDB ਫਾਈਲਾਂ ਸਮਰਥਿਤ ਹਨ",
    upload_sql_to_generate_diagrams:
      "ਆਪਣੇ ਟੇਬਲਾਂ ਅਤੇ ਕਾਲਮਾਂ ਨੂੰ ਆਪਣੇ ਆਪ ਜਨਰੇਟ ਕਰਨ ਲਈ ਇੱਕ SQL ਫਾਈਲ ਅੱਪਲੋਡ ਕਰੋ।",
    overwrite_existing_diagram: "ਮੌਜੂਦਾ ਡਾਯਾਗ੍ਰਾਮ ਨੂੰ ਓਵਰਰਾਈਟ ਕਰੋ",
    only_mysql_supported:
      "*ਇਸ ਸਮੇਂ ਸਿਰਫ MySQL ਸਕ੍ਰਿਪਟਾਂ ਨੂੰ ਲੋਡ ਕਰਨਾ ਸਮਰਥਿਤ ਹੈ।",
    blank: "ਖਾਲੀ",
    filename: "ਫਾਈਲ ਨਾਮ",
    table_w_no_name: "ਬਿਨਾਂ ਨਾਮ ਵਾਲੀ ਟੇਬਲ ਘੋਸ਼ਿਤ ਕੀਤੀ ਗਈ",
    duplicate_table_by_name: "ਨਾਮ '{{tableName}}' ਨਾਲ ਨਕਲ ਟੇਬਲ",
    empty_field_name: "ਟੇਬਲ '{{tableName}}' ਵਿੱਚ ਖਾਲੀ ਖੇਤਰ `ਨਾਮ`",
    empty_field_type: "ਟੇਬਲ '{{tableName}}' ਵਿੱਚ ਖਾਲੀ ਖੇਤਰ `ਕਿਸਮ`",
    no_values_for_field:
      "ਟੇਬਲ '{{tableName}}' ਦੇ ਖੇਤਰ '{{fieldName}}' ਦੀ ਕਿਸਮ `{{type}}` ਹੈ ਪਰ ਕੋਈ ਮੁੱਲ ਨਿਰਧਾਰਤ ਨਹੀਂ ਹੈ",
    default_doesnt_match_type:
      "ਟੇਬਲ '{{tableName}}' ਦੇ ਖੇਤਰ '{{fieldName}}' ਦੀ ਡਿਫਾਲਟ ਮੁੱਲ ਉਸਦੀ ਕਿਸਮ ਨਾਲ ਮੇਲ ਨਹੀਂ ਖਾਂਦੀ",
    not_null_is_null:
      "ਟੇਬਲ '{{tableName}}' ਦੇ ਖੇਤਰ '{{fieldName}}' ਦੀ ਮੁੱਲ NOT NULL ਹੈ ਪਰ ਡਿਫਾਲਟ NULL ਹੈ",
    duplicate_fields:
      "ਟੇਬਲ '{{tableName}}' ਵਿੱਚ '{{fieldName}}' ਨਾਮ ਵਾਲੇ ਨਕਲ ਟੇਬਲ ਖੇਤਰ",
    duplicate_index:
      "ਟੇਬਲ '{{tableName}}' ਵਿੱਚ '{{indexName}}' ਨਾਮ ਵਾਲਾ ਨਕਲ ਇੰਡੈਕਸ",
    empty_index:
      "ਟੇਬਲ '{{tableName}}' ਵਿੱਚ ਇੰਡੈਕਸ ਕਿਸੇ ਵੀ ਕਾਲਮ ਨੂੰ ਇੰਡੈਕਸ ਨਹੀਂ ਕਰਦਾ",
    no_primary_key: "ਟੇਬਲ '{{tableName}}' ਵਿੱਚ ਕੋਈ ਪ੍ਰਾਥਮਿਕ ਕੁੰਜੀ ਨਹੀਂ ਹੈ",
    type_with_no_name: "ਬਿਨਾਂ ਕਿਸੇ ਨਾਮ ਵਾਲੇ ਕਿਸਮ ਨੂੰ ਘੋਸ਼ਿਤ ਕੀਤਾ",
    duplicate_types: "ਨਾਮ '{{typeName}}' ਵਾਲੀ ਨਕਲ ਕਿਸਮ",
    type_w_no_fields:
      "ਬਿਨਾਂ ਕਿਸੇ ਖੇਤਰ ਵਾਲੀ ਕਿਸਮ '{{typeName}}' ਨੂੰ ਘੋਸ਼ਿਤ ਕੀਤਾ",
    empty_type_field_name: "ਕਿਸਮ '{{typeName}}' ਵਿੱਚ ਖਾਲੀ ਖੇਤਰ `ਨਾਮ`",
    empty_type_field_type: "ਕਿਸਮ '{{typeName}}' ਵਿੱਚ ਖਾਲੀ ਖੇਤਰ `ਕਿਸਮ`",
    no_values_for_type_field:
      "ਕਿਸਮ '{{typeName}}' ਦੇ ਖੇਤਰ '{{fieldName}}' ਦੀ ਕਿਸਮ `{{type}}` ਹੈ ਪਰ ਕੋਈ ਮੁੱਲ ਨਿਰਧਾਰਤ ਨਹੀਂ ਹੈ",
    duplicate_type_fields:
      "ਕਿਸਮ '{{typeName}}' ਵਿੱਚ '{{fieldName}}' ਨਾਮ ਵਾਲੇ ਨਕਲ ਕਿਸਮ ਖੇਤਰ",
    duplicate_reference: "ਨਾਮ '{{refName}}' ਵਾਲਾ ਨਕਲ ਸੰਦਰਭ",
    circular_dependency: "ਟੇਬਲ '{{refName}}' ਵਿੱਚ ਚੱਕਰਕਾਰ ਨਿਰਭਰਤਾ",
    timeline: "ਟਾਈਮਲਾਈਨ",
    priority: "ਪ੍ਰਾਥਮਿਕਤਾ",
    none: "ਕੋਈ ਨਹੀਂ",
    low: "ਹੋਣਹਾਰ",
    medium: "ਦਰਮਿਆਨਾ",
    high: "ਉੱਚਾ",
    sort_by: "ਅਨੁਸਾਰ ਕ੍ਰਮਬੱਧ ਕਰੋ",
    my_order: "ਮੇਰਾ ਕ੍ਰਮ",
    completed: "ਪੂਰਾ ਹੋਇਆ",
    alphabetically: "ਵਰਨਮਾਲਾ ਅਨੁਸਾਰ",
    add_task: "ਕੰਮ ਸ਼ਾਮਲ ਕਰੋ",
    details: "ਵੇਰਵੇ",
    no_tasks: "ਤੁਹਾਡੇ ਕੋਲ ਅਜੇ ਤੱਕ ਕੋਈ ਕੰਮ ਨਹੀਂ ਹੈ।",
    no_activity: "ਤੁਹਾਡੇ ਕੋਲ ਅਜੇ ਤੱਕ ਕੋਈ ਗਤੀਵਿਧੀ ਨਹੀਂ ਹੈ।",
    move_element: "{{name}} ਨੂੰ {{coords}} 'ਤੇ ਲਿਜਾਓ",
    edit_area: "{{extra}} ਖੇਤਰ ਸੋਧੋ {{areaName}}",
    delete_area: "ਖੇਤਰ ਮਿਟਾਓ {{areaName}}",
    edit_note: "{{extra}} ਨੋਟ ਸੋਧੋ {{noteTitle}}",
    delete_note: "ਨੋਟ ਮਿਟਾਓ {{noteTitle}}",
    edit_table: "{{extra}} ਟੇਬਲ ਸੋਧੋ {{tableName}}",
    delete_table: "ਟੇਬਲ ਮਿਟਾਓ {{tableName}}",
    edit_type: "{{extra}} ਕਿਸਮ ਸੋਧੋ {{typeName}}",
    delete_type: "ਕਿਸਮ ਮਿਟਾਓ {{typeName}}",
    add_relationship: "ਸਬੰਧ ਸ਼ਾਮਲ ਕਰੋ",
    edit_relationship: "{{extra}} ਸਬੰਧ ਸੋਧੋ {{refName}}",
    delete_relationship: "ਸਬੰਧ ਮਿਟਾਓ {{refName}}",
    not_found: "ਨਹੀਂ ਮਿਲਿਆ",
  },
};

export { pa, punjabi };
